import {
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/solid";
import { format } from "date-fns";
import { useState } from "react";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import { useDebounce } from "usehooks-ts";
import Pagination from "../../components/Pagination";
import { useCookie } from "../../hooks/useCookie";
import { general } from "../../locales/general";
import apiService from "../../service/apiService";
import { removeEmptyFilterQueries } from "../../helpers/general";
import { apiConfig } from "../../config/apiConfig";
import qs from "qs";

const PAGE_SIZE = 10;

export default function PartnerAccounts() {
  const { token } = useCookie("vToken");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const search = useDebounce(searchQuery, 1000);

  const query = {
    _q: search,
    filters: {
      $and: [
        {
          role: { label: { $eq: "Partner" } },
        },
      ],
    },
    pagination: {
      limit: PAGE_SIZE,
      page: currentPage,
    },
  };

  const endpoint = apiConfig.users.list(
    removeEmptyFilterQueries(qs.stringify(query, { encode: false })),
  );
  const searchDependencies = ["getAllUsers", token, endpoint];
  const { data, isLoading } = useQuery(
    searchDependencies,
    () => {
      return apiService.MakeGetRequest(endpoint, token);
    },
    { keepPreviousData: true },
  );
  return (
    <div>
      <div className="d-flex justify-content-end mt-2 mb-3">
        <div className="search-form">
          <div className="input-field">
            <MagnifyingGlassIcon color="gray" width={20} />
            <input
              type="text"
              className="w-50 border-0 outline-none rounded-sm p-1 text-gray fs-6"
              placeholder="Rechercher"
              onChange={(e) => {
                setCurrentPage(1);
                setSearchQuery(e.target.value.toLowerCase());
              }}
            />
          </div>
        </div>
      </div>

      <CTable>
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell scope="col" className="text-sm">
              Date
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-sm">
              Nom complet
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-sm">
              Email
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-sm">
              Téléphone
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-sm">
              Ville
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-sm">
              Créé par
            </CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {data?.items?.map((user: User) => (
            <CTableRow key={user.id}>
              <CTableDataCell className="text-sm">
                {format(new Date(user.createdAt), "dd/MM/yyyy")}
              </CTableDataCell>
              <CTableDataCell className="text-sm">
                <Link to={`/users/${user.id}`} className="fw-semibold">
                  {user.fullName}
                </Link>
              </CTableDataCell>
              <CTableDataCell className="text-sm">{user.email}</CTableDataCell>
              <CTableDataCell className="text-sm">{user.phone}</CTableDataCell>
              <CTableDataCell className="text-sm">
                {user.city?.label}
              </CTableDataCell>
              <CTableDataCell className="text-sm">
                {/* {user.createdBy?.fullName ?? "—"}
                 */}
                 -
              </CTableDataCell>
            </CTableRow>
          ))}
        </CTableBody>
      </CTable>

      {!isLoading && !data?.items?.length && (
        <p className="text-center fs-5 my-2">{general.fr.noData}</p>
      )}

      <Pagination
        currentPage={currentPage}
        onPageChange={setCurrentPage}
        siblingCount={0}
        totalCount={data?.meta?.totalPages}
        pageSize={PAGE_SIZE}
      />
    </div>
  );
}
